// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-tab[data-v-026f1af6]{transition:all .2s ease-in-out;cursor:pointer;font-weight:500;padding:1rem 0}@media(prefers-reduced-motion:reduce){.v-tab[data-v-026f1af6]{transition:none}}@media(max-width:767.98px){.v-tab[data-v-026f1af6]{flex:1 0 auto;text-align:center}}.v-tab[data-v-026f1af6]:not(:last-child){margin-right:1rem}.v-tab--active[data-v-026f1af6],.v-tab[data-v-026f1af6]:hover{color:#3670ff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
